import { render, staticRenderFns } from "./MTAllianceAuthorization.vue?vue&type=template&id=06fbc5e4"
import script from "./MTAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./MTAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06fbc5e4')) {
      api.createRecord('06fbc5e4', component.options)
    } else {
      api.reload('06fbc5e4', component.options)
    }
    module.hot.accept("./MTAllianceAuthorization.vue?vue&type=template&id=06fbc5e4", function () {
      api.rerender('06fbc5e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/MTAllianceAuthorization.vue"
export default component.exports